import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { ConfluenceLogo } from "@atlaskit/logo";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { Separator } from "@/components/signup/account-creation/components/separator/separator";
import { Social } from "@/components/signup/account-creation/components/social/social";
import { Submit } from "@/components/signup/account-creation/components/submit/submit";
import { BlueWaveTemplate } from "@/components/signup/layouts/blue-wave-template";
import { Picture } from "@/components/wpl/image/src/image";

import { NoCreditCardRequired } from "../../components/no-credit-card-required";

import { HubspotDockerTwilioGoPro } from "./hubspot-docker-twilio-gopro";

export const LoggedOutConfluenceBlueWaveTemplate = ({
    productEditionText
}: {
    productEditionText: string;
}) => {
    const { formatMessage } = useIntl();
    return (
        <BlueWaveTemplate
            productEditionText={productEditionText}
            socialProofLogos={<HubspotDockerTwilioGoPro />}
            tagline={formatMessage({
                id: "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence",
                defaultMessage: "Trusted by over 75,000 teams worldwide"
            })}
            valueProps={formatMessage(
                {
                    id: "WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence",
                    defaultMessage:
                        "Kickstart team collaboration{newline}Increase transparency{newline}Capture all the knowledge{newline}Build admirable content"
                },
                { newline: "{newline}" }
            ).split("{newline}")}
            productLogos={[
                <ConfluenceLogo appearance="inverse" size="xlarge" key="jsm" />
            ]}
            illustration={
                <Picture
                    image={{
                        src: "https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg",
                        alt: ""
                    }}
                />
            }
        >
            <div css={containerCss}>
                <h2 css={siteActivationHeadingCss}>
                    {formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading",
                        defaultMessage: "Start now"
                    })}
                </h2>
                <p css={subheaderCss}>
                    {formatMessage({
                        id: "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence",
                        defaultMessage:
                            "7-day free trial for up to 50,000 users"
                    })}
                </p>
                <AccountCreation
                    Submit={
                        <>
                            <Submit
                                buttonText={formatMessage({
                                    id: "WacSignupForm.startButtonTextChooseSignup",
                                    defaultMessage: "Continue"
                                })}
                            />
                            <NoCreditCardRequired />
                        </>
                    }
                    Separator={
                        <Separator
                            separatorText={formatMessage({
                                id: "WacSignupForm.socialSignUpOr",
                                defaultMessage: "OR"
                            })}
                        />
                    }
                    Social={
                        <Social
                            providers={{
                                google: formatMessage({
                                    id: "WacSignupForm.socialSignUpButtonContinueWithGoogle",
                                    defaultMessage: "Continue with Google"
                                })
                            }}
                        />
                    }
                />
            </div>
        </BlueWaveTemplate>
    );
};

const containerCss = css({
    display: "grid",
    gap: "16px",
    marginBlockEnd: 48
});

const siteActivationHeadingCss = css({
    fontSize: 36,
    fontWeight: 500,
    margin: 0,
    textAlign: "center"
});

const subheaderCss = css({
    fontSize: 16,
    textAlign: "center",
    margin: 0
});
